import axios from "axios";
import { getAttribution } from "@/utils/attribution";

const ERP_API_BASE = process.env.REACT_APP_API_BASE;
const SITE_API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Primary: direct POST to ERP with attribution. On any failure, fall back to the
// site backend WITHOUT skip_erp so the server-side webhook still delivers to the ERP.
export async function submitLead(payload) {
  const enriched = { ...payload, ...getAttribution() };
  try {
    await axios.post(`${ERP_API_BASE}/api/contact`, enriched);
    axios.post(`${SITE_API}/contact`, { ...enriched, skip_erp: true }).catch(() => {});
  } catch (e) {
    await axios.post(`${SITE_API}/contact`, enriched);
  }
}
